import {Grid, MenuItem, TextField} from "@mui/material";
import React from "react";

const CustomTextFieldGrid = ({title, menuItems, onChangeHandler, myRef, value, helperText, type, maxLength, label, error, onKeyDown, required, onKeyPress, isPassword, showMeter, max}) => {
    return(
        <Grid container flexDirection={"row"} justifyContent={"space-between"}>
            <Grid item xs={4} alignSelf={"center"}><p>{title}</p></Grid>
            <Grid item xs={8}  alignSelf={"center"}>
                {value && !isPassword && <TextField
                    error={error}
                    required={required}
                    className={'roundedInput textFieldColor dark-font-color required'}
                    id={title}
                    type={type}
                    select={typeof menuItems !== 'undefined'}
                    size={"small"}
                    value={value}
                    onChange={onChangeHandler}
                    onKeyPress={onKeyPress}
                    onKeyDown={onKeyDown}
                    helperText={helperText}
                    inputProps={{maxLength}}
                    fullWidth>
                    {typeof menuItems !== 'undefined' && menuItems.map(title => {
                        return (
                            <MenuItem key={title} value={title}>
                                {title}
                            </MenuItem>
                        );
                    })}
                </TextField>}
                {typeof myRef !== 'undefined' && !isPassword &&

                <TextField
                    error={error}
                    required={required}
                    className ={'roundedInput textFieldColor dark-font-color '+ (required ? "required":"")}
                    inputRef={myRef}
                    id='username'
                    type={type}
                    size={"small"}
                    onChange={onChangeHandler}
                    helperText={helperText}
                    onKeyPress={onKeyPress}
                    inputProps={{maxLength}}
                    fullWidth/>}
            </Grid>
        </Grid>
    );
};

export default CustomTextFieldGrid;